import type { AppParams } from "@/types/scheduling";
import type { InsuranceValue, OperationalMode, PaymentType } from "shared/types";

export const getURLParams = (): AppParams => {
  const urlParams = new URLSearchParams(window.location.search);
  let results: AppParams = {
    state: urlParams.get("state") || "",
    nutrition_area: urlParams.get("nutrition_area") || "",
    expertise: urlParams.get("expertise") || "",
    payment_method: (urlParams.get("payment_method") as PaymentType) || undefined,
    insurance_provider: (urlParams.get("insurance_provider") as InsuranceValue) || undefined,
    insurance_provider_other: urlParams.get("insurance_provider_other") || undefined,
    lead_name: urlParams.get("lead_name") || undefined,
    lead_email: urlParams.get("lead_email") || undefined,
    lead_phone_number: urlParams.get("lead_phone_number") || undefined,
    communication_style: urlParams.get("communication_style") || undefined,
    provider_id: urlParams.get("provider_id") || undefined,
    plan_id: urlParams.get("plan_id") || undefined,
    op_mode: (urlParams.get("op_mode") as OperationalMode) || undefined,
  };
  return results;
};
